var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _path3, _rect6, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcelPrdct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 88,
    viewBox: "0 0 100 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    width: 75,
    height: 87.5,
    rx: 2,
    fill: "#2FB776"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 65.625H100V85.5C100 86.6046 99.1046 87.5 98 87.5H27C25.8954 87.5 25 86.6046 25 85.5V65.625Z",
    fill: "url(#paint0_linear_2919_116)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 43.75,
    width: 37.5,
    height: 21.875,
    fill: "#229C5B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 21.875,
    width: 37.5,
    height: 21.875,
    fill: "#27AE68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 2C25 0.895431 25.8954 0 27 0H62.5V21.875H25V2Z",
    fill: "#1D854F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 21.875,
    width: 37.5,
    height: 21.875,
    fill: "#197B43"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 43.75,
    width: 37.5,
    height: 21.875,
    fill: "#1B5B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24.875C25 23.2181 26.3431 21.875 28 21.875H59.5C61.1569 21.875 62.5 23.2181 62.5 24.875V75.125C62.5 76.7819 61.1569 78.125 59.5 78.125H25V24.875Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 15.625,
    width: 56.25,
    height: 56.25,
    rx: 2,
    fill: "url(#paint1_linear_2919_116)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 59.375L31.8192 43.4375L40.2384 28.125H33.3656L28.168 37.9018L23.0563 28.125H15.9686L24.4308 43.4375L15.625 59.375H22.4979L28.0391 49.0179L33.5374 59.375H40.625Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2919_116",
    x1: 25,
    y1: 76.5625,
    x2: 100,
    y2: 76.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2919_116",
    x1: 0,
    y1: 43.75,
    x2: 56.25,
    y2: 43.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176F3D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelPrdct);
export default __webpack_public_path__ + "static/media/excel-prdct.e638ca687f03fcc64b8369766d8a55f9.svg";
export { ForwardRef as ReactComponent };